export default "__VITE_ASSET__BYUSgj8i__"